import React, { FunctionComponent, useCallback, useMemo, useState } from 'react'
import { GenericInput } from '@dxp-module/common'
import { IconButton, InputAdornment } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { MyAccountWidgetProps } from '../../../model/MyAccountWidgetProps'
import passwordWidgetStyles from './passwordWidget.styles'

const PasswordWidget: FunctionComponent<MyAccountWidgetProps> = props => {
  const {
    label,
    required,
    id,
    onChange,
    value,
    options,
    placeholder,
    rawErrors,
    disabled,
    schema,
    uiSchema,
  } = props

  const [isVisible, setIsVisible] = useState<boolean>(false)

  const { readOnly, disabled: schemaDisabled } = schema as typeof schema & {
    disabled: boolean
  }
  const inputAdornment = uiSchema['ui:options']?.inputAdornment

  const handleClick = useCallback(() => {
    setIsVisible(prev => !prev)
  }, [])

  const handleChange = useCallback(
    (e: React.ChangeEvent<{ value: string }>) => {
      onChange(e.target.value as string)
    },
    [value]
  )

  const currentError = useMemo(() => {
    if (rawErrors) {
      return rawErrors?.length > 0 ? rawErrors[0] : undefined
    }
  }, [rawErrors])

  const error = currentError
    ? {
        props: {
          id: currentError,
          defaultMessage: currentError,
        },
      }
    : undefined

  const styles = passwordWidgetStyles()

  const isDisabled = disabled || schemaDisabled

  return (
    <GenericInput
      label={label}
      required={required}
      id={id}
      value={value}
      currentError={error}
      onChange={handleChange}
      type={isVisible ? 'text' : String(options?.inputType) || undefined}
      inputLabel={!!options?.inputLabel || !!label}
      placeholder={placeholder}
      disabled={isDisabled}
      readOnly={readOnly}
      {...(inputAdornment && {
        startAdornment: (
          <InputAdornment position="start">{inputAdornment}</InputAdornment>
        ),
      })}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            disableRipple
            className={styles.eyeIconButton}
            onClick={handleClick}
          >
            {isVisible ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
      classes={styles}
    />
  )
}

export default PasswordWidget
